import { gql } from "@apollo/client";

export default gql`
  mutation cancelSpecialOfferPackage($customerId: ID!){
    cancelSpecialOfferPackage(customerId: $customerId){
        success
        data{
            _id
            name
            monthlyPrice
            yearlyPrice
            createdAt
            limits{
                cPerson
                cPersonRoles
                person
                whatsAppWeb
                whatsAppBusiness
                metaWhatsAppBusiness
                facebook
                email
                instagram
                tiktok
                telegram
                trendyol
                amazon
                hepsiburada
                ebay
                kaufland
                pazarama
                walmart
                n11
                teams
                apiKeys
                webhooks
                inboxRules
                flowBots
                survey
                liveChat
                customChannel
                message
                aiAnswers
                zoho
                callMinutes
                phone
                aiAssistant
                ticket
                qpienShop
                ikas
                faprika
                ticimax
                tsoft
                ideasoft
                shopify
                googleBusiness
                slaPolicies
                tables
                tableRecords
                customReports
                operatorCredits
            }
            features{
                dashboard
                inbox
                inboxPrivateMessage
                inboxBulkActions
                inboxCustomViews
                inboxMessageTranslation
                contacts
                contactsDynamicGroups
                contactsMergeContacts
                contactsImport
                contactsExport
                statistics
                statisticsConversations
                statisticsMessages
                statisticsUsers
                statisticsPerformance
                statisticsSatisfactions
                statisticsAbandonedCarts
                statisticsCampaign
                settings
                settingsUsers
                settingsUserRoles
                settingsActions
                settingsAuthentications
                settingsApiKeys
                settingsWebhooks
                settingsTeams
                settingsTags
                settingsQuickAnswers
                settingsAutoAssignment
                settingsTeamGoals
                settingsSlaPolicies
                settingsTopics
                settingsTopicsAutoFill
                settingsCustomFields
                settingsSurveys
                channels
                channelsLiveChat
                channelsCustomChannel
                channelsLiveChatRemoveQpienLogo
                channelsEmail
                channelsSms
                channelsPhone
                channelsWhatsAppWeb
                channelsWhatsAppBusinessApi
                channelsMetaWhatsAppBusinessApi
                channelsTelegram
                channelsFacebookDm
                channelsFacebookComment
                channelsInstagramDm
                channelsInstagramComment
                channelsTiktokDm
                channelsTiktokComment
                channelsMarketplace
                campaignEngineV2
                automation
                automationFlowBots
                teamChat
                automationEcommerce
                automationFlowBotsHttpRequest
                automationFlowBotsStartFlow
                channelsEcommerce
                channelsPhoneCallRecord
                channelsPhoneInboundCalls
                channelsPhoneSurvey
                channelsPhoneOutboundCalls
                channelsPhoneTestToSpeech
                channelsPhonelVR
                statisticsConversationTags
                ai
                aiAnalysis
                AiAgent
                AiAssistant
                AiClosingTag
                AiClosingNote
                AiClosingSurvey
                AiStartFlow
                AiStatistics
                aiImageRecognition
                bulkSharing
                zohoIntegration
                collageSharing
                tasks
                snooze
                messageSchedule
                channelsPhoneCallTranscripts
                channelsPhoneCallAiAnalysis
                removeEmailQpienLogo
                tables
                customReports
                channelOwner
                userActivity
                autoAway
            }
        }
        code
        message
    }
}
`
